import type { CardStatus } from "./cardHelpers";

/** All card statuses the backend can report. */
export const CARD_STATUSES: readonly CardStatus[] = [
  "ACTIVE",
  "FROZEN",
  "DISABLED",
  "DELETED",
  "PENDING_REVIEW",
] as const;

/** Type guard: is the raw string a known CardStatus? */
export const isValidCardStatus = (status: string | undefined): status is CardStatus =>
  !!status && (CARD_STATUSES as readonly string[]).includes(status);

/**
 * DISABLED and DELETED are terminal on the backend — unlike FROZEN, they cannot be undone. Used to switch the
 * confirmation modal to its destructive variant.
 */
export const isIrreversibleStatus = (status: string | undefined): boolean =>
  status === "DISABLED" || status === "DELETED";

/** I18n key (cards namespace) for each card status label. */
export const CARD_STATUS_TKEY: Record<CardStatus, string> = {
  ACTIVE: "status_active",
  FROZEN: "status_frozen",
  DISABLED: "status_disabled",
  DELETED: "status_deleted",
  PENDING_REVIEW: "status_pending_review",
};
